"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundSelectListRequest = void 0;
var FundSelectListRequest = /** @class */ (function () {
    function FundSelectListRequest() {
    }
    return FundSelectListRequest;
}());
exports.FundSelectListRequest = FundSelectListRequest;
;
//# sourceMappingURL=fundSelectList.request.js.map